/**
 * Nazwy tabel
 *
 * @export
 * @enum {number}
 */
export enum TableName {
  assessment = 'assessment',
  attachment = 'attachment',
  decision = 'decision',
  document = 'document',
  document_pack = 'document_pack',
  invoice = 'invoice',
  procedure = 'procedure',
  profile = 'profile',
  stage = 'stage',
  status = 'status',
  structure_node = 'structure_node'
}

/**
 * Nazwy tabel przetłumaczone do wyświetlania w historii
 *
 * @export
 * @enum {number}
 */
export enum TableNameTranslations {
  assessment = 'oceny',
  attachment = 'załącznika',
  decision = 'decyzji',
  document = 'wniosku',
  document_pack = 'paczki wniosków',
  invoice = 'faktury',
  procedure = 'procedury',
  profile = 'profilu',
  stage = 'etapu',
  status = 'statusu',
  structure_node = 'szkoły'
}
